import { Text } from '@southfields-digital/mxmz-react-ui';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Graphic, { IGraphicProps } from 'src/components/Graphic';
import { StateType } from 'src/redux/reducers';
import {
  REQUEST_ANIMATE_IN_LIVE_GRAPHIC,
  REQUEST_ANIMATE_OUT_LIVE_GRAPHIC,
} from 'src/redux/reducers/control';

import styles from './BundledGraphics.module.scss';

const noop = () => {};

export default function BundledGraphics() {
  const dispatch = useDispatch();

  const { bundledPlaylistGraphics } = useSelector(
    (state: StateType) => state.bundledPlaylistGraphic
  );

  const handleToggleLive = useCallback(
    (graphic: PlaylistGraphic) => {
      dispatch({
        type: graphic.status?.live
          ? REQUEST_ANIMATE_OUT_LIVE_GRAPHIC
          : REQUEST_ANIMATE_IN_LIVE_GRAPHIC,
        payload: { playlistGraphicId: graphic.id },
      });
    },
    [dispatch]
  );

  const items: IGraphicProps[] = useMemo(() => {
    if (!bundledPlaylistGraphics) return [];

    return bundledPlaylistGraphics.map((graphic) => ({
      id: graphic.id,
      text: graphic.name,
      isQuick: false,
      live: graphic.status?.live ?? false,
      active: false,
      variant: 'static',
      parent: null,
      sortable: false,
      canConnect: false,
      showIsConcept: false,
      isConcept: false,
      onLive: () => handleToggleLive(graphic),
      onClick: noop,
      onDuplicate: noop,
      onQuickify: noop,
      onDelete: noop,
      onConcept: noop,
      onConnect: noop,
      graphic: graphic.graphic,
    }));
  }, [bundledPlaylistGraphics, handleToggleLive]);

  if (!bundledPlaylistGraphics?.length) {
    return (
      <div className={styles.NoContent}>
        <Text as="p">No bundled graphics</Text>
      </div>
    );
  }

  return (
    <div className={styles.Container}>
      {items.map((item) => (
        <Graphic key={item.id} {...item} />
      ))}
    </div>
  );
}
